export interface TargetToleranceProps {
  initialGreen: number;
  initialOrange: number;
  updateGreenTolerance: (value: number) => void;
  updateOrangeTolerance: (value: number) => void;
  dataTestId?: string;
  isDisabled?: boolean;
}

export const INVALID_VALUES = 'Orange tolerance must be greater or equal to Green tolerance';
